import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Перенаправляем на страницу пользователей по умолчанию
    throw redirect({ to: '/couriers' })
  },
})
